import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaProcedures, FaPenSquare } from "react-icons/fa";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { CircularProgress } from "@mui/material";
import { API_URL } from "../../api";

function BookableTreatments() {
  const token = localStorage.getItem("token");
  const api = axios.create({
    baseURL: API_URL(),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [bookableDesc, setBookableDesc] = useState("");
  const [bookableImage, setBookableImage] = useState(null);
  const [preview, setPreview] = useState("");

  const getBookableTreatments = async () => {
    setIsLoading(true);
    try {
      const res = await api.get("v2/bookable-treatments/list");
      setTreatmentLists(res.data?.list || []);
    } catch (err) {
      Swal.fire("Error", err?.response?.data?.message || err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBookableTreatments();
  }, []);

  const handleOpen = (item) => {
    setSelectedItem(item);
    setBookableDesc(item?.description || "");
    setPreview(item?.image || "");
    setBookableImage(null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBookableImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async () => {
    if (!selectedItem) return;

    const formData = new FormData();

    if (bookableDesc) {
      formData.append("description", bookableDesc);
    }

    if (bookableImage) {
      formData.append("image", bookableImage);
    }

    try {
      await api.patch(
        `v2/bookable-treatment/${selectedItem._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire({
        title: "Successful!",
        text: "Bookable Treatment Updated Successfully!",
        icon: "success",
      });

      handleClose();
      getBookableTreatments();
    } catch (err) {
      Swal.fire(
        "Error",
        err?.response?.data?.message || err.message,
        "error"
      );
    }
  };

  return (
    <div className="App">
      <div className="wrapper">
        <div style={{ paddingBottom: "1.5rem" }}>
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Bookable Treatments</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <FaProcedures /> Bookable Treatments
                  </h3>
                </div>

                <div className="card-body">
                  {isLoading ? (
                    <div className="text-center py-5">
                      <CircularProgress />
                    </div>
                  ) : (
                    <table className="table">
                      <thead className="text-center bg-info">
                        <tr>
                          <th>No</th>
                          <th>Code</th>
                          <th>Name</th>
                          <th>Body Parts</th>
                          <th>Image</th>
                          <th>Description</th>
                          <th style={{ whiteSpace: "nowrap", width: "1%" }}>Action</th>
                        </tr>
                      </thead>
                        <tbody className="text-center">
                          {treatmentLists.length > 0 ? (
                            treatmentLists.map((item, i) => {
                              const treatment = item.relatedTreatmentList;

                              return (
                                <tr key={item._id || i}>
                                  <td>{i + 1}</td>

                                  <td>{treatment?.code || "-"}</td>

                                  <td>{treatment?.name || "-"}</td>

                                  <td>{treatment?.bodyParts?.name || "-"}</td>

                                  <td>
                                    {item?.image ? (
                                      <img
                                        src={item.image}
                                        alt={treatment?.name || "treatment"}
                                        style={{
                                          width: "60px",
                                          height: "40px",
                                          objectFit: "cover",
                                          borderRadius: "4px",
                                        }}
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td>{item.description || "-"}</td>

                                  <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                                    <button
                                      className="btn btn-warning btn-sm"
                                      onClick={() => handleOpen(item)}
                                    >
                                      <FaPenSquare />
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                No bookable treatments available
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>
            <div className="modal-header bg-info">
              <h4 className="modal-title">
                Bookable Details - {selectedItem?.name}
              </h4>
              <button
                type="button"
                className="close"
                onClick={handleClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="modal-body">
              <div class="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control border-info"
                  accept="image/*"
                  onChange={handleImageChange}
                />
                {preview && (
                  <div className="mt-2">
                    <img
                      src={preview}
                      alt="Preview"
                      style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "4px" }}
                    />
                  </div>
                )}
              </div>
              <div class="form-group">
                <label>Description</label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={bookableDesc}
                  onChange={(e) => setBookableDesc(e.target.value)}
                  placeholder="Enter bookable treatment description..."
                ></textarea>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button className="btn btn-secondary" onClick={handleClose}>
              Cancel
            </button>
            <button className="btn btn-info" onClick={handleSave}>
              Save
            </button>
          </DialogActions>
        </Dialog>

        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    </div>
  );
}

export default BookableTreatments;